import Tooltip from '../Tooltip/Tooltip'
import classes from './RunSelectedStepTagBadge.module.scss'

export interface Props {
  display?: 'flex' | 'inline-block' | 'block'
  label: string
}

const RunSelectedStepTagBadge = ({
  display = 'inline-block',
  label
}: Props) => (
  <Tooltip label={label}>
    <span
      aria-label={label}
      className={classes.RunSelectedStepTagBadge + ' ' + classes[display]}
    >
      {label}
    </span>
  </Tooltip>
)

export default RunSelectedStepTagBadge
